import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 8,
  class: "material-icons ble-lite__type-icon"
}
const _hoisted_7 = { class: "ble-lite__name" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 10,
  class: "ble-lite__right"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "ble-lite-menu__sep"
}
const _hoisted_14 = {
  key: 5,
  class: "ble-lite-menu__sep"
}
const _hoisted_15 = {
  key: 8,
  class: "ble-lite-menu__sep"
}
const _hoisted_16 = {
  key: 0,
  class: "ble-lite-menu__sep"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 11,
  class: "ble-lite-menu__sep"
}
const _hoisted_19 = {
  key: 1,
  class: "ble-lite-menu__sep"
}
const _hoisted_20 = {
  key: 3,
  class: "ble-lite-menu__sep"
}

import { computed, ref, reactive, nextTick, watch, onMounted, onBeforeUnmount } from 'vue';
// @ts-ignore
import DndListElement from '@/components/dnd/DndListElement.vue';
// @ts-ignore
import DndReorderElement from '@/components/dnd/DndReorderElement.vue';
import NativeInput from '@/components/common/basic/NativeInput.vue';
import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
import { BaseListItem } from './interfaces/ListTypes';
import { BaseItemTypes, DragItemTypes } from '@/components/dnd/ItemTypes';
import { trimEllip } from '@/models/helpers/recursive';
import { buildClientUrl } from '@/utils/urlHelpers';
import folderClosedSvg from '@/assets/folder-closed.svg';
import folderOpenSvg from '@/assets/folder-open.svg';
import folderClosedPlusSvg from '@/assets/folder-closed-plus.svg';
import folderOpenPlusSvg from '@/assets/folder-open-plus.svg';
import folderClosedPlusHoverSvg from '@/assets/folder-closed-plus-hover.svg';
import folderOpenPlusHoverSvg from '@/assets/folder-open-plus-hover.svg';

// Предзагрузка hover-иконок папок, чтобы при ховере не было сетевых запросов
import heartSvg from '@/assets/heart.svg';
import heartActiveSvg from '@/assets/heart-active.svg';
import listIconSvg from '@/assets/list-icon.svg';
import pieChartIconSvg from '@/assets/pie-chart-icon.svg';
import barChartIconSvg from '@/assets/bar-chart-icon.svg';
import lineChartIconSvg from '@/assets/line-chart-icon.svg';
import moreVertIconSvg from '@/assets/more-vert-icon.svg';
import moreVertIconHoverSvg from '@/assets/more-vert-icon-hover.svg';
import editIconSvg from '@/assets/edit-icon.svg';
import editIconHoverSvg from '@/assets/edit-icon-hover.svg';
import { getAnalyticsV2ElementTypeName } from '@/models/helpers/type-names';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import ElementInfoDialog from './ElementInfoDialog.vue';
import MostaContextMenu from '@/components/common/basic/MostaContextMenu.vue';
import { generalStore } from '@/store/general';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseListElementLite',
  props: {
    element: {},
    depth: {},
    isRoot: { type: Boolean },
    hasChildren: { type: Boolean },
    effectiveExpanded: { type: Boolean },
    inputIndex: {},
    parentId: {},
    parentType: {},
    intoForbidden: { type: [Boolean, Function] },
    scrollViewport: {},
    allowHighlightOnHover: { type: Function },
    allowHoverAction: { type: Function },
    allowChildToChildDropAction: { type: Function },
    allowChildToRootDropAction: { type: Function },
    allowRootToChildDropAction: { type: Function },
    selectionMode: { type: Boolean },
    isChecked: { type: Boolean },
    renameSiblings: {},
    isInherited: { type: Boolean },
    isCreateFolderPendingForThisParent: { type: Boolean },
    isMovePendingForThisItem: { type: Boolean },
    inReportContext: { type: Boolean },
    betweenRootDropViaIndicator: { type: Boolean },
    canDropToRootForDrag: { type: Function }
  },
  emits: ["toggleExpand", "cardSelected", "cardDeleted", "cardFavorite", "cardRenamed", "cardCloned", "switchProjection", "changeParent", "changePosition", "cardMoved", "breakAfter", "addChildSelection", "addChildProjection", "addChildList", "addChildChart", "addChildFolder", "addToReport", "enterSelectionMode", "toggleItemSelection"],
  setup(__props: any, { emit: __emit }) {

[folderClosedPlusSvg, folderOpenPlusSvg, folderClosedPlusHoverSvg, folderOpenPlusHoverSvg].forEach(src => {
  const img = new Image();
  img.src = src;
});

const genstore = generalStore();


const props = __props;

const $q = useQuasar();
const emit = __emit;

const noop = () => {};

/** Узел сегмента «Отчёты»: либо сам REPORT-корень, либо любой его потомок (определяется родителем-отчётом). */
const isReportNode = computed(() => props.element.elType === BaseItemTypes.REPORT);

/**
 * Одноразовая подсветка элемента, на который перешли по ссылке (GET-параметры).
 * Строгое сравнение Identity: для папок — elType + FolderId, для остальных — elType + Id + SrcType + DestType.
 * Гасится первым кликом мыши (clearLinkHighlight в VirtualAnalyticsList).
 */
const isLinkHighlighted = computed(() => {
  const hl: any = genstore.linkHighlight;
  if (!hl) return false;
  const el: any = props.element;
  if (hl.elType === BaseItemTypes.FOLDER) {
    return el.elType === BaseItemTypes.FOLDER && el.FolderId === hl.FolderId;
  }
  return el.elType === hl.elType &&
    el.Id === hl.Id &&
    (hl.SrcType ? el.SrcType === hl.SrcType : !el.SrcType) &&
    el.DestType === hl.DestType;
});
/** В отчётном дереве (REPORT-корень + любые потомки): прокидывается из VirtualAnalyticsList. */
const isReportTreeNode = computed(() => !!props.inReportContext);
/** Разрешение «вложить»: выборка/список/папка всегда принимают перенос; остальные — только без ElementId и не графики. */
const baseIntoAllowed = computed(() => {
  // В отчётном дереве «вкладывать» нельзя: REPORT-корень и его дети — только sibling-reorder.
  if (isReportTreeNode.value) return false;
  return [BaseItemTypes.SELECTION, BaseItemTypes.LIST, BaseItemTypes.FOLDER].includes(props.element.elType) ||
    (!props.element.ElementId && ![1, 2, 3, 4].includes(props.element.elType));
});
/** Для DnD: если intoForbidden — функция (проверка папка в себя/вложенную), передаём функцию в dnd-list-element.
 *  Для отчётного дерева используется DndReorderElement, который ждёт строго boolean — поэтому для report-узлов
 *  всегда возвращаем false и не оборачиваем в функцию. */
const intoAllowedComputed = computed(() => {
  const base = baseIntoAllowed.value;
  if (isReportTreeNode.value) return false;
  if (typeof props.intoForbidden === 'function') {
    // Для корневых папок (CARD_ROOT) не применяем intoForbidden при дропе root→root: там потомков быть не может,
    // и запрет «в себя» обрабатывается отдельно через allowRootToRootDropAction.
    return (dragParams: any, hoverParams: any) => {
      return base && !(props.intoForbidden as (d: any, h: any) => boolean)(dragParams, hoverParams);
    };
  }
  return base && !props.intoForbidden;
});

/**
 * Какой DnD-компонент использовать:
 * - В отчётном дереве — DndReorderElement (sibling-reorder с индикатором между элементами);
 * - В остальных сегментах — DndListElement (нынешнее поведение: смена родителя «во вложение»).
 */
const dndComponent = computed(() => isReportTreeNode.value ? DndReorderElement : DndListElement);

/**
 * Подменю «Действия» в контекстном меню. В отчётном дереве оно скрыто:
 * операции «Создать вложенную выборку / Клонировать / Добавить проекцию / Создать список /
 * Добавить графики / Добавить в отчёт» к узлам отчёта неприменимы.
 */
const showActionsSection = computed(() => !isReportTreeNode.value);

/**
 * Hover-иконка «Добавить разрыв». Доступна только для табличных элементов внутри отчёта
 * (у REPORT-корня и у разрывов разделителя — нет, у них нет ElementId).
 */
const canAddBreak = computed(() => isReportTreeNode.value && !isReportNode.value && !!(props.element as any).ElementId);
const nameInput = ref<InstanceType<typeof NativeInput> | null>(null);
const menuAnchor = ref<HTMLElement | null>(null);
const menuOpen = ref(false);
const menuPos = ref({ top: '0px', left: '0px' });
const actionsSubOpen = ref(false);
const projSubOpen = ref(false);
const EMPTY_TOKENS: string[] = [];

const showHoverActions = ref(false);
const isRowHovered = ref(false);
const isFolderIconHovered = ref(false);
const isEditIconHovered = ref(false);
const isMenuIconHovered = ref(false);
let hoverTimer: ReturnType<typeof setTimeout> | null = null;
let menuCloseTimer: ReturnType<typeof setTimeout> | null = null;
let actionsSubCloseTimer: ReturnType<typeof setTimeout> | null = null;
let projSubCloseTimer: ReturnType<typeof setTimeout> | null = null;

// Подсказка «Ссылка скопирована в буфер обмена» после copyLink:
// показываем штатный q-tooltip, привязанный к невидимому фиксированному
// anchor-блоку в координатах клика, и сами скрываем через 2с.
const copyTipShown = ref(false);
const copyTipPos = reactive({ x: 0, y: 0 });
let copyTipTimer: ReturnType<typeof setTimeout> | null = null;

function onRowEnter() {
  isRowHovered.value = true;
  if (hoverTimer) clearTimeout(hoverTimer);
  hoverTimer = setTimeout(() => { showHoverActions.value = true; }, 400);
}

function onRowLeave() {
  isRowHovered.value = false;
  isEditIconHovered.value = false;
  if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
  showHoverActions.value = false;
}

onBeforeUnmount(() => {
  if (hoverTimer) clearTimeout(hoverTimer);
  if (menuCloseTimer) clearTimeout(menuCloseTimer);
  if (actionsSubCloseTimer) clearTimeout(actionsSubCloseTimer);
  if (projSubCloseTimer) clearTimeout(projSubCloseTimer);
  if (copyTipTimer) clearTimeout(copyTipTimer);
  document.removeEventListener('mousedown', onDocumentMousedown, true);
});

onMounted(() => {
  document.addEventListener('mousedown', onDocumentMousedown, true);
});

/** Тип DnD: для выборок различаем корневые/дочерние (CARD_ROOT/CARD_CHILD), для папок достаточно одного типа CARD_CHILD (правила для папок не зависят от корневости). */
const dragType = computed(() =>
  props.isRoot && props.element.elType !== BaseItemTypes.FOLDER ? 'card_root' : 'card_child'
);

/** Класс-placeholder под стрелку: полную ширину под шеврон резервируем у папок, корневых элементов и у всего, что лежит прямо в папке — тогда тексты выборок/списков/графиков встают ровно под вложенной папкой того же уровня. Для элементов, вложенных в другие элементы (выборку/список/проекцию), оставляем компактный отступ. */
const chevronPlaceholderClass = computed(() => {
  const isFolderType = props.element.elType === BaseItemTypes.FOLDER;
  const isRootCard = props.isRoot;
  const parentIsFolder = props.parentType === BaseItemTypes.FOLDER;
  return isFolderType || isRootCard || parentIsFolder ? 'ble-lite__no-chevron--full' : 'ble-lite__no-chevron';
});

/** Эффективное состояние раскрытия: используем рассчитанное в VirtualAnalyticsList (поиск/избранное), иначе fallback к локальному search-auto-expand. */
const effectiveExpanded = computed(() =>
  props.effectiveExpanded ?? (!!props.element.isExpanded || (props.element as any)._searchAutoExpand === true)
);

/** Параметры для DnD и moveItemToParent. isRoot — буквально корневой (без родителя); «корневая выборка по смыслу» считается в allowRootToRootDropAction.
 * ВАЖНО: Id и FolderId передаём РАЗДЕЛЬНО (id = Id, folderId = FolderId), чтобы для сравнения использовать ту же самую Identity, что и при выборе.
 */
const callbackParams = computed(() => ({
  id: props.element.Id,
  folderId: props.element.FolderId,
  parent_id: props.parentId,
  parent_type: props.parentType,
  isRoot: props.isRoot,
  elType: props.element.elType,
  sourceDataType: props.element.SrcType,
  isEditing: props.element.isEditing,
  isProcessing: isTemporarilyBlocked.value,
  isExpanded: props.element.isExpanded,
  destinationDataType: props.element.DestType,
  innerElementId: props.element.ElementId,
  CombinedName: props.element.CombinedName,
  Name: props.element.Name,
  viewport: props.scrollViewport,
}));

const isTemporarilyBlocked = computed(() =>
  !!props.isCreateFolderPendingForThisParent
  || !!props.isMovePendingForThisItem
  || !!(props.element as any).isLoadingChildren
);

const canDragCheck = () =>
  !isTemporarilyBlocked.value &&
  !props.element.isEditing &&
  (!props.selectionMode || !!props.isChecked);

const rowStyle = computed(() => ({ paddingLeft: (props.depth * 22) + 'px' }));

const isFolder = computed(() => props.element.elType === BaseItemTypes.FOLDER);

const folderIcon = computed(() => {
  if (isFolderIconHovered.value) {
    return effectiveExpanded.value ? folderOpenPlusHoverSvg : folderClosedPlusHoverSvg;
  }
  if (isRowHovered.value) {
    return effectiveExpanded.value ? folderOpenPlusSvg : folderClosedPlusSvg;
  }
  return effectiveExpanded.value ? folderOpenSvg : folderClosedSvg;
});

const typeIcon = computed(() => {
  switch (props.element.elType) {
    case BaseItemTypes.FOLDER: return '';
    case BaseItemTypes.LIST: return '';
    case BaseItemTypes.GRAPH: return '';
    case BaseItemTypes.PIE_CHART: return '';
    case BaseItemTypes.BAR_CHART: return '';
    case BaseItemTypes.BREAK: return 'height';
    default: return '';
  }
});

const editIconForDisplay = computed(() =>
  isEditIconHovered.value ? editIconHoverSvg : editIconSvg
);

const moreVertIconForDisplay = computed(() =>
  isMenuIconHovered.value ? moreVertIconHoverSvg : moreVertIconSvg
);

const searchTokens = computed(() => (props.element as any)._searchTokens || EMPTY_TOKENS);
const editDraftName = ref(props.element.Name || '');

function isSameIdentity(left: BaseListItem, right: BaseListItem): boolean {
  if (!left || !right) return false;
  if (left.elType === BaseItemTypes.FOLDER && right.elType === BaseItemTypes.FOLDER) {
    return left.FolderId === right.FolderId;
  }
  return left.elType === right.elType &&
    left.Id === right.Id &&
    ((right.SrcType !== undefined && right.SrcType !== null) ? (left.SrcType === right.SrcType) : !left.SrcType) &&
    left.DestType === right.DestType;
}

function hasDuplicateOnLevel(name: string): boolean {
  const siblings = props.renameSiblings || [];
  return siblings.some((candidate) =>
    candidate &&
    candidate.elType === props.element.elType &&
    candidate.Name === name &&
    !isSameIdentity(candidate, props.element),
  );
}

const isDuplicateNameWarning = computed(() => {
  if (!props.element.isEditing) return false;
  if (!editDraftName.value) return false;
  return hasDuplicateOnLevel(editDraftName.value);
});

const projLink = computed(() => {
  const el = props.element;
  if (el.elType && el.elType <= 1) {
    return ` (${getAnalyticsV2ElementTypeName(el.SrcType)} → ${getAnalyticsV2ElementTypeName(el.DestType)})`;
  }
  return '';
});

/** Проекция «корневая по смыслу»: либо буквально корневая, либо лежит в папке (родитель — не выборка). */
const isRootProjectionByMeaning = computed(() =>
  props.element.elType === BaseItemTypes.PROJECTION &&
  (props.isRoot || props.parentType === BaseItemTypes.FOLDER)
);

/** Список «корневой по смыслу»: либо буквально корневой, либо лежит в папке. */
const isRootListByMeaning = computed(() =>
  props.element.elType === BaseItemTypes.LIST &&
  (props.isRoot || props.parentType === BaseItemTypes.FOLDER)
);

/** Условие показа пункта «Создать (вложенную) выборку» — используется и для пункта, и для защиты разделителя перед графиками. */
const showAddChildSelection = computed(() =>
  [0, 6, 7].includes(props.element.elType) ||
  (props.element.elType === 1 && (props.isRoot || props.parentType === BaseItemTypes.FOLDER))
);

const showProjectionSection = computed(() =>
  props.element.DestType !== 5 && props.element.DestType !== 6 &&
  ([0, 6].includes(props.element.elType) || isRootProjectionByMeaning.value)
);

/** Пункты подменю «Добавить проекцию»: фиксированный порядок, те же условия видимости по DestType. */
const projectionSubmenuItems = computed(() => {
  const destType = props.element.DestType;
  const defs: { prType: number; labelKey: string; destTypes: number[] }[] = [
    { prType: 1, labelKey: 'submenu_to_clients', destTypes: [0, 2, 3, 4] },
    { prType: 0, labelKey: 'submenu_to_projects', destTypes: [1, 2, 3, 4] },
    { prType: 2, labelKey: 'submenu_to_jobs', destTypes: [3] },
    { prType: 4, labelKey: 'submenu_to_files', destTypes: [0, 1] },
    { prType: 8, labelKey: 'submenu_to_movements', destTypes: [7] },
    { prType: 7, labelKey: 'submenu_to_positions', destTypes: [8] },
  ];
  return defs.filter((d) => d.destTypes.includes(destType));
});

const showChartsSection = computed(() => {
  if (props.element.DestType === 5) return false; // на сегменте тегов графики скрываем

  const elType = props.element.elType;
  const isRootSelectionByMeaning =
    elType === BaseItemTypes.SELECTION &&
    (props.isRoot || props.parentType === BaseItemTypes.FOLDER);

  // Графики можно добавлять:
  // - у буквальных корневых выборок/проекций/списков
  // - у «корневых по смыслу» выборок, проекций и списков (когда лежат в папке)
  // - у папок
  return (
    (props.isRoot && [BaseItemTypes.SELECTION, BaseItemTypes.PROJECTION, BaseItemTypes.LIST].includes(elType)) ||
    isRootSelectionByMeaning ||
    isRootProjectionByMeaning.value ||
    isRootListByMeaning.value ||
    elType === BaseItemTypes.FOLDER
  );
});

const showFavorite = computed(() =>
  props.element.elType !== BaseItemTypes.REPORT &&
  props.element.elType !== BaseItemTypes.BREAK
);

// В режиме отчётов (сам отчёт или любой его потомок) массовое выделение недоступно.
const canToggleElementSelection = computed(() => !props.selectionMode && !isReportTreeNode.value);

// В режиме редактирования клик по самому элементу (паддинг строки, иконки, шеврон)
// не должен снимать фокус с contenteditable — иначе blur сбросит редактирование.
// Предотвращаем потерю фокуса, кроме кликов внутри самого поля ввода.
function onRowMouseDown(event: MouseEvent) {
  if (!props.element.isEditing) return;
  const target = event.target as HTMLElement | null;
  if (target && typeof target.closest === 'function' && target.closest('.ble-lite__name-edit')) return;
  event.preventDefault();
}

function selectItem() {
  if (props.element.isEditing || isTemporarilyBlocked.value) return;
  // В режиме выделения клик по строке переключает галку, не выбирая элемент.
  // Исключение — узлы дерева отчётов: для них массовое выделение не применяется,
  // клик работает как обычный выбор.
  if (props.selectionMode && !isReportTreeNode.value) {
    emit('toggleItemSelection', callbackParams.value);
    return;
  }
  if (props.element.isSelected) {
    emit('cardSelected', { element: props.element, switch: false, clearSelection: true });
    return;
  }
  emit('cardSelected', { element: props.element, switch: false });
}

function startEdit() {
  if (!props.element.isEditing) {
    // eslint-disable-next-line vue/no-mutating-props
    props.element.isEditing = true;
    editDraftName.value = props.element.Name || '';
    nextTick(() => nameInput.value?.startEdit());
  }
}

function focusEditFromExternalState() {
  nextTick(() => nameInput.value?.startEdit());
}

onMounted(() => {
  if (props.element.isEditing) {
    focusEditFromExternalState();
  }
});

watch(
  () => props.element.isEditing,
  (isEditing, wasEditing) => {
    if (isEditing && !wasEditing) {
      editDraftName.value = props.element.Name || '';
      focusEditFromExternalState();
      return;
    }
    if (!isEditing && wasEditing) {
      editDraftName.value = props.element.Name || '';
    }
  },
);

function onNameUpdated(newName: string) {
  if (hasDuplicateOnLevel(newName)) {
    return;
  }
  if (newName && newName !== props.element.Name) {
    emit('cardRenamed', { element: props.element, newName });
  }
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isEditing = false;
}

function onNameLiveValue(value: string) {
  editDraftName.value = value ?? '';
}

// При revert (blur/Esc без коммита) NativeInput не эмитит update:modelValue,
// поэтому isEditing нужно сбросить отдельно по событию blur.
function onEditBlur() {
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isEditing = false;
}

async function copyLink() {
  const el = props.element;
  const linkId = el.elType === BaseItemTypes.FOLDER ? el.FolderId : el.Id;
  if (!linkId) return;
  const url = buildClientUrl(`analyticsvue?type=${el.elType}&src=${el.SrcType === undefined ? '' : el.SrcType}&dest=${el.DestType}&id=${linkId}`);

  let copied = false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      copied = true;
    }
  } catch (_e) {
    // Clipboard API can be blocked by browser permissions policy.
  }

  if (!copied) {
    // Fallback for environments where Clipboard API is unavailable/blocked.
    const textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    copied = true;
  }

  if (copied) {
    showCopyTooltip();
  }
}

// Показываем штатный q-tooltip («Ссылка скопирована в буфер обмена») рядом
// с координатой клика. Через 2с снимаем; повторные клики перезапускают таймер.
function showCopyTooltip() {
  copyTipShown.value = true;
  if (copyTipTimer !== null) {
    clearTimeout(copyTipTimer);
    copyTipTimer = null;
  }
  copyTipTimer = setTimeout(() => {
    copyTipShown.value = false;
    copyTipTimer = null;
  }, 2000);
}

function setMenuPosition(anchor: HTMLElement) {
  const rect = anchor.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
  const margin = 8;
  const menuGapX = 2;
  // По запросу UI даём небольшой сдвиг вправо относительно кнопки «...».
  const anchorRight = rect.right + menuGapX;
  const anchorTop = rect.top;
  // Первый проход до рендера: ставим возле якоря.
  menuPos.value = {
    top: `${Math.max(margin, anchorTop)}px`,
    left: `${Math.max(margin, Math.min(anchorRight, viewportWidth - 200 - margin))}px`,
  };

  // Второй проход после рендера: учитываем фактический размер меню.
  nextTick(() => {
    const menuEl = document.querySelector('.ble-lite-menu') as HTMLElement | null;
    if (!menuEl) return;
    const menuRect = menuEl.getBoundingClientRect();
    const menuHeight = Math.ceil(menuRect.height);
    const menuWidth = Math.ceil(menuRect.width);

    let top = anchorTop;
    if (top + menuHeight > viewportHeight - margin) {
      top = viewportHeight - menuHeight - margin;
    }
    if (top < margin) top = margin;
    if (top + menuHeight > viewportHeight - margin) top = Math.max(margin, viewportHeight - menuHeight - margin);

    let left = anchorRight;
    if (left + menuWidth > viewportWidth - margin) {
      left = viewportWidth - menuWidth - margin;
    }
    if (left < margin) left = margin;

    menuPos.value = { top: `${top}px`, left: `${left}px` };
  });
}

function clearMenuCloseTimer() {
  if (menuCloseTimer) {
    clearTimeout(menuCloseTimer);
    menuCloseTimer = null;
  }
}

function clearActionsSubCloseTimer() {
  if (actionsSubCloseTimer) {
    clearTimeout(actionsSubCloseTimer);
    actionsSubCloseTimer = null;
  }
}

function clearProjSubCloseTimer() {
  if (projSubCloseTimer) {
    clearTimeout(projSubCloseTimer);
    projSubCloseTimer = null;
  }
}

// Буфер нужен, чтобы курсор успел пройти gap между пунктом и подменю.
function scheduleActionsSubClose() {
  clearActionsSubCloseTimer();
  actionsSubCloseTimer = setTimeout(() => {
    actionsSubOpen.value = false;
    projSubOpen.value = false;
    actionsSubCloseTimer = null;
    clearProjSubCloseTimer();
  }, 180);
}

function scheduleProjSubClose() {
  clearProjSubCloseTimer();
  projSubCloseTimer = setTimeout(() => {
    projSubOpen.value = false;
    projSubCloseTimer = null;
  }, 180);
}

// Небольшой буфер нужен, чтобы курсор можно было перевести с кнопки на меню без закрытия.
function scheduleMenuClose() {
  clearMenuCloseTimer();
  menuCloseTimer = setTimeout(() => {
    menuOpen.value = false;
    actionsSubOpen.value = false;
    projSubOpen.value = false;
    clearActionsSubCloseTimer();
    clearProjSubCloseTimer();
    menuCloseTimer = null;
  }, 220);
}

function openMenu(anchor: HTMLElement) {
  clearMenuCloseTimer();
  setMenuPosition(anchor);
  menuOpen.value = true;
  actionsSubOpen.value = true;
  projSubOpen.value = false;
}

function onMenuIconEnter(ev: MouseEvent) {
  isMenuIconHovered.value = true;
  openMenu(ev.currentTarget as HTMLElement);
}

function onMenuIconLeave() {
  isMenuIconHovered.value = false;
  scheduleMenuClose();
}

function onElementMenuEnter() {
  clearMenuCloseTimer();
}

function onElementMenuLeave() {
  scheduleMenuClose();
}

function onActionsSubTriggerEnter() {
  clearActionsSubCloseTimer();
  actionsSubOpen.value = true;
}

function onActionsSubTriggerLeave() {
  scheduleActionsSubClose();
}

function onActionsSubMenuEnter() {
  clearActionsSubCloseTimer();
  actionsSubOpen.value = true;
}

function onActionsSubMenuLeave() {
  scheduleActionsSubClose();
}

function onProjSubTriggerEnter() {
  clearProjSubCloseTimer();
  projSubOpen.value = true;
}

function onProjSubTriggerLeave() {
  scheduleProjSubClose();
}

function onProjSubMenuEnter() {
  clearProjSubCloseTimer();
  projSubOpen.value = true;
}

function onProjSubMenuLeave() {
  scheduleProjSubClose();
}

function onDocumentMousedown(ev: MouseEvent) {
  if (!menuOpen.value) return;
  const target = ev.target as HTMLElement | null;
  if (!target) return;
  if (menuAnchor.value && menuAnchor.value.contains(target)) return;
  // Клик внутри меню не должен закрывать его до обработки действия пункта.
  if (typeof target.closest === 'function' && target.closest('.ble-lite-menu')) return;
  clearMenuCloseTimer();
  clearActionsSubCloseTimer();
  clearProjSubCloseTimer();
  menuOpen.value = false;
  actionsSubOpen.value = false;
  projSubOpen.value = false;
}

function toggleMenu(ev: MouseEvent) {
  clearMenuCloseTimer();
  const anchor = ev.currentTarget as HTMLElement;
  setMenuPosition(anchor);
  const nextOpen = !menuOpen.value;
  menuOpen.value = nextOpen;
  actionsSubOpen.value = nextOpen;
  projSubOpen.value = false;
}

function hoverParams() {
  return {
    id: props.element.Id,
    folderId: props.element.FolderId,
    isRoot: props.isRoot,
    elType: props.element.elType,
    isEditing: props.element.isEditing,
    isExpanded: props.element.isExpanded,
    sourceDataType: props.element.SrcType,
    destinationDataType: props.element.DestType,
    innerElementId: props.element.ElementId,
    viewport: props.scrollViewport,
    CombinedName: props.element.CombinedName,
  };
}

function triggerAddChildFolderFromIcon() {
  if (props.element.elType !== BaseItemTypes.FOLDER || isTemporarilyBlocked.value) return;
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isExpanded = true;
  emit('addChildFolder', { hoverParams: hoverParams() });
}

function menuAction(action: string, e?: MouseEvent) {
  clearMenuCloseTimer();
  clearActionsSubCloseTimer();
  clearProjSubCloseTimer();
  menuOpen.value = false;
  actionsSubOpen.value = false;
  projSubOpen.value = false;
  if (action === 'selectElement') { emit('enterSelectionMode', callbackParams.value); return; }
  if (action === 'copyLink') {
    // Запоминаем координаты клика, чтобы показать tooltip ровно у пункта меню
    // (после закрытия меню сам пункт уже не существует, поэтому используем фикс. anchor).
    if (e && typeof e.clientX === 'number' && typeof e.clientY === 'number') {
      copyTipPos.x = e.clientX;
      copyTipPos.y = e.clientY;
    }
    copyLink();
    return;
  }
  if (action === 'delete') {
    const rect = menuAnchor.value?.getBoundingClientRect();
    const pos = rect ? { x: rect.left - 115, y: rect.top } : { x: 0, y: 0 };
    emit('cardDeleted', props.element, pos);
    return;
  }
  if (action === 'favorite') { emit('cardFavorite', { element: props.element }); return; }
  if (action === 'info') {
    $q.dialog({
      component: ElementInfoDialog,
      componentProps: { element: props.element },
    });
    return;
  }
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isExpanded = true;
  const hp = hoverParams();
  switch (action) {
    case 'addChildSelection': emit('addChildSelection', { hoverParams: hp }); break;
    case 'addChildFolder': triggerAddChildFolderFromIcon(); break;
    case 'clone': emit('cardCloned', props.element); break;
    case 'addChildList': emit('addChildList', { hoverParams: hp }); break;
    case 'addToReport': emit('addToReport', props.element); break;
  }
}

function menuProjection(prType: number) {
  clearActionsSubCloseTimer();
  clearProjSubCloseTimer();
  menuOpen.value = false;
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isExpanded = true;
  emit('addChildProjection', { hoverParams: hoverParams(), pr_type: prType });
}

function menuChart(chartType: number) {
  clearActionsSubCloseTimer();
  clearProjSubCloseTimer();
  menuOpen.value = false;
  // eslint-disable-next-line vue/no-mutating-props
  props.element.isExpanded = true;
  emit('addChildChart', { hoverParams: { ...hoverParams(), chartType } });
}

/**
 * «Добавить разрыв после» — отчётный экшен. Бэк ожидает (ReportId, BreakPosition):
 *   ReportId — Id родительского отчёта, BreakPosition — позиция в его ChildReportElements.
 * Текущий элемент — дитя REPORT-корня, поэтому parentId/parentType содержат identity отчёта.
 * newpos = sibling-index (по renameSiblings) + 1.
 */
function addBreakAfter() {
  if (!canAddBreak.value) return;
  if (props.parentType !== BaseItemTypes.REPORT || props.parentId == null) return;
  const siblings = props.renameSiblings || [];
  const idx = siblings.indexOf(props.element);
  if (idx < 0) return;
  emit('breakAfter', { Id: props.parentId, newpos: idx + 1 });
}

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(dndComponent.value), {
      ref: "dndel",
      id: _ctx.element.elType === _unref(BaseItemTypes).FOLDER ? _ctx.element.FolderId : _ctx.element.Id,
      index: _ctx.inputIndex,
      "highlight-condition": _ctx.allowHighlightOnHover,
      "hover-condition": noop,
      CtcDropCondition: _ctx.allowChildToChildDropAction,
      CtrDropCondition: _ctx.allowChildToRootDropAction,
      RtrDropCondition: _ctx.allowHoverAction,
      RtcDropCondition: _ctx.allowRootToChildDropAction,
      type: dragType.value,
      "into-allowed": intoAllowedComputed.value,
      "max-height": 28,
      "callback-params": callbackParams.value,
      "element-name": _ctx.element.Name,
      "can-drag-check": canDragCheck,
      "between-root-drop-via-indicator": !isReportTreeNode.value && _ctx.betweenRootDropViaIndicator,
      "can-drop-to-root-check": !isReportTreeNode.value ? _ctx.canDropToRootForDrag : undefined,
      onChangeParent: _cache[22] || (_cache[22] = (p) => _ctx.$emit('changeParent', p)),
      onChangePosition: _cache[23] || (_cache[23] = (p) => _ctx.$emit('changePosition', p)),
      onCardMoved: _cache[24] || (_cache[24] = (p) => _ctx.$emit('cardMoved', p)),
      draggable: !isTemporarilyBlocked.value && !_ctx.element.isEditing
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['ble-lite', { 'ble-lite--selected': _ctx.element.isSelected, 'ble-lite--link-highlight': isLinkHighlighted.value, 'ble-lite--expanded': effectiveExpanded.value && _ctx.hasChildren, 'ble-lite--menu-open': menuOpen.value, 'ble-lite--actions-visible': showHoverActions.value, 'ble-lite--blocked': isTemporarilyBlocked.value }]),
          style: _normalizeStyle(rowStyle.value),
          onMouseenter: onRowEnter,
          onMouseleave: onRowLeave
        }, [
          _createElementVNode("div", {
            class: "ble-lite__row",
            onClick: selectItem,
            onMousedown: onRowMouseDown
          }, [
            (_ctx.selectionMode && !isReportTreeNode.value)
              ? (_openBlock(), _createBlock(MostaCheckbox, {
                  key: 0,
                  class: "ble-lite__selection-check",
                  "model-value": _ctx.isChecked,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleItemSelection', callbackParams.value))),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["model-value"]))
              : _createCommentVNode("", true),
            (_ctx.hasChildren)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["ble-lite__chevron", { 'ble-lite__chevron--open': effectiveExpanded.value }]),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('toggleExpand', _ctx.element)), ["stop"]))
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("svg", {
                    class: "ble-lite__chevron-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M4 6L8 10L12 6",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  _createVNode(_component_q_tooltip, {
                    delay: 300,
                    anchor: "top middle",
                    self: "center middle",
                    class: "ble-lite__chevron-tooltip-popup"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(effectiveExpanded.value ? 'collapse_list' : 'expand_list')), 1)
                    ]),
                    _: 1
                  })
                ], 2))
              : (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(chevronPlaceholderClass.value)
                }, null, 2)),
            (isFolder.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  class: "ble-lite__type-icon ble-lite__type-icon--folder",
                  src: folderIcon.value,
                  onClick: _withModifiers(triggerAddChildFolderFromIcon, ["stop"]),
                  onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (isFolderIconHovered.value = true)),
                  onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isFolderIconHovered.value = false))
                }, null, 40, _hoisted_1))
              : (_ctx.element.elType === _unref(BaseItemTypes).LIST)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 4,
                    class: "ble-lite__type-icon ble-lite__type-icon--list",
                    src: _unref(listIconSvg)
                  }, null, 8, _hoisted_2))
                : (_ctx.element.elType === _unref(BaseItemTypes).PIE_CHART)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 5,
                      class: "ble-lite__type-icon",
                      src: _unref(pieChartIconSvg)
                    }, null, 8, _hoisted_3))
                  : (_ctx.element.elType === _unref(BaseItemTypes).BAR_CHART)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 6,
                        class: "ble-lite__type-icon",
                        src: _unref(barChartIconSvg)
                      }, null, 8, _hoisted_4))
                    : (_ctx.element.elType === _unref(BaseItemTypes).GRAPH)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 7,
                          class: "ble-lite__type-icon ble-lite__type-icon--line",
                          src: _unref(lineChartIconSvg)
                        }, null, 8, _hoisted_5))
                      : (typeIcon.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6, _toDisplayString(typeIcon.value), 1))
                        : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: _normalizeClass(["ble-lite__name-flow", { 'ble-lite__name-flow--editing': _ctx.element.isEditing }])
              }, [
                _createVNode(NativeInput, {
                  ref_key: "nameInput",
                  ref: nameInput,
                  class: "ble-lite__name-edit",
                  "model-value": _ctx.element.Name,
                  "allow-line-break": false,
                  "disabled-field": !_ctx.element.isEditing,
                  "highlight-tokens": searchTokens.value,
                  "underline-edit": true,
                  "external-warning": isDuplicateNameWarning.value,
                  "external-warning-text": _ctx.$t('rename_duplicate_name_exists'),
                  "revert-on-blur": true,
                  "onUpdate:modelValue": onNameUpdated,
                  onLiveValue: onNameLiveValue,
                  onBlur: onEditBlur
                }, null, 8, ["model-value", "disabled-field", "highlight-tokens", "external-warning", "external-warning-text"]),
                (projLink.value && !_ctx.element.isEditing)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "ble-lite__proj-link",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('switchProjection', { element: _ctx.element, isRoot: _ctx.isRoot })), ["stop"]))
                    }, _toDisplayString(projLink.value), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (!isTemporarilyBlocked.value && !_ctx.element.isEditing)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "ble-lite__edit-btn",
                    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (isEditIconHovered.value = true)),
                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (isEditIconHovered.value = false)),
                    onClick: _withModifiers(startEdit, ["stop"])
                  }, [
                    _createElementVNode("img", {
                      src: editIconForDisplay.value,
                      class: "ble-lite__edit-btn-icon",
                      draggable: "false"
                    }, null, 8, _hoisted_8),
                    _createVNode(_component_q_tooltip, {
                      delay: 300,
                      anchor: "top middle",
                      self: "center middle"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('rename')), 1)
                      ]),
                      _: 1
                    })
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.element.isEditing && !isTemporarilyBlocked.value && _ctx.element.IsFavorite && !isReportNode.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 9,
                  src: _unref(heartActiveSvg),
                  class: "ble-lite__heart-indicator"
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (!_ctx.element.isEditing && !isTemporarilyBlocked.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (canAddBreak.value)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "material-icons ble-lite__act ble-lite__act-break",
                        title: _ctx.$t('add_break'),
                        onClick: _withModifiers(addBreakAfter, ["stop"])
                      }, "height", 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: moreVertIconForDisplay.value,
                    class: "ble-lite__act ble-lite__act-menu",
                    ref_key: "menuAnchor",
                    ref: menuAnchor,
                    onMouseenter: onMenuIconEnter,
                    onMouseleave: onMenuIconLeave,
                    onClick: _withModifiers(toggleMenu, ["stop"])
                  }, null, 40, _hoisted_12)
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ], 38),
        _createVNode(MostaContextMenu, {
          visible: menuOpen.value,
          position: menuPos.value,
          "min-width": 200,
          "disable-backdrop-pointer": true,
          "menu-class": "ble-lite-menu",
          onClose: _cache[21] || (_cache[21] = ($event: any) => (menuOpen.value = false)),
          onMenuEnter: onElementMenuEnter,
          onMenuLeave: onElementMenuLeave
        }, {
          default: _withCtx(() => [
            (showActionsSection.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ble-lite-menu__item ble-lite-menu__item--sub",
                  onMouseenter: onActionsSubTriggerEnter,
                  onMouseleave: onActionsSubTriggerLeave
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('menu_actions')) + " ", 1),
                  _cache[28] || (_cache[28] = _createElementVNode("svg", {
                    class: "ble-lite-menu__sub-arrow",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M6 12L10 8L6 4",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  (actionsSubOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "ble-lite-menu__submenu",
                        onMouseenter: onActionsSubMenuEnter,
                        onMouseleave: onActionsSubMenuLeave
                      }, [
                        (showAddChildSelection.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "ble-lite-menu__item",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (menuAction('addChildSelection')))
                            }, _toDisplayString(_ctx.element.elType === 7 ? _ctx.$t('create_selection') : _ctx.$t('create_child_selection')), 1))
                          : _createCommentVNode("", true),
                        (showAddChildSelection.value && showChartsSection.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                          : _createCommentVNode("", true),
                        (showChartsSection.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "ble-lite-menu__item",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (menuChart(2)))
                            }, _toDisplayString(_ctx.$t('add_linear_chart')), 1))
                          : _createCommentVNode("", true),
                        (showChartsSection.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "ble-lite-menu__item",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (menuChart(3)))
                            }, _toDisplayString(_ctx.$t('add_pie_chart')), 1))
                          : _createCommentVNode("", true),
                        (showChartsSection.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 4,
                              class: "ble-lite-menu__item",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (menuChart(4)))
                            }, _toDisplayString(_ctx.$t('add_bar_chart')), 1))
                          : _createCommentVNode("", true),
                        (showChartsSection.value && (_ctx.element.elType === 7 || ![901].includes(_ctx.element.elType)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                          : _createCommentVNode("", true),
                        (_ctx.element.elType === 7)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 6,
                              class: "ble-lite-menu__item",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (menuAction('addChildFolder')))
                            }, _toDisplayString(_ctx.$t('create_folder')), 1))
                          : _createCommentVNode("", true),
                        (![901].includes(_ctx.element.elType))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 7,
                              class: "ble-lite-menu__item",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (menuAction('clone')))
                            }, _toDisplayString(_ctx.$t('clone')), 1))
                          : _createCommentVNode("", true),
                        (showProjectionSection.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                          : _createCommentVNode("", true),
                        (showProjectionSection.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 9,
                              class: "ble-lite-menu__item ble-lite-menu__item--sub",
                              onMouseenter: onProjSubTriggerEnter,
                              onMouseleave: onProjSubTriggerLeave
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('add_projection')) + " ", 1),
                              _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                class: "ble-lite-menu__sub-arrow",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none"
                              }, [
                                _createElementVNode("path", {
                                  d: "M6 12L10 8L6 4",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)),
                              (projSubOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "ble-lite-menu__submenu",
                                    onMouseenter: onProjSubMenuEnter,
                                    onMouseleave: onProjSubMenuLeave
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectionSubmenuItems.value, (item, idx) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: item.prType
                                      }, [
                                        (idx > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: "ble-lite-menu__item",
                                          onClick: ($event: any) => (menuProjection(item.prType))
                                        }, _toDisplayString(_ctx.$t(item.labelKey)), 9, _hoisted_17)
                                      ], 64))
                                    }), 128))
                                  ], 32))
                                : _createCommentVNode("", true)
                            ], 32))
                          : _createCommentVNode("", true),
                        ([0,1,6].includes(_ctx.element.elType) && [0,1,2,3,4,5,7,8].includes(_ctx.element.DestType))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 10,
                              class: "ble-lite-menu__item",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (menuAction('addChildList')))
                            }, _toDisplayString(_ctx.$t('create_list')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.element.elType !== 7)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                          : _createCommentVNode("", true),
                        (_ctx.element.elType !== 7)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 12,
                              class: "ble-lite-menu__item",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (menuAction('addToReport')))
                            }, _toDisplayString(_ctx.$t('add_to_report')), 1))
                          : _createCommentVNode("", true)
                      ], 32))
                    : _createCommentVNode("", true)
                ], 32))
              : _createCommentVNode("", true),
            (canToggleElementSelection.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : _createCommentVNode("", true),
            (canToggleElementSelection.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "ble-lite-menu__item",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (menuAction('selectElement')))
                }, _toDisplayString(_ctx.$t('menu_select_element')), 1))
              : _createCommentVNode("", true),
            (showFavorite.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20))
              : _createCommentVNode("", true),
            (showFavorite.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "ble-lite-menu__item",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (menuAction('favorite')))
                }, _toDisplayString(_ctx.element.IsFavorite ? _ctx.$t('remove_from_favorites') : _ctx.$t('add_to_favorites')), 1))
              : _createCommentVNode("", true),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "ble-lite-menu__sep" }, null, -1)),
            _createElementVNode("div", {
              class: "ble-lite-menu__item",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (menuAction('copyLink', $event)))
            }, _toDisplayString(_ctx.$t('copy_link')), 1),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "ble-lite-menu__sep" }, null, -1)),
            _createElementVNode("div", {
              class: "ble-lite-menu__item",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (menuAction('info')))
            }, _toDisplayString(_ctx.$t('menu_view_information')), 1),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "ble-lite-menu__sep" }, null, -1)),
            _createElementVNode("div", {
              class: "ble-lite-menu__item",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (menuAction('delete')))
            }, _toDisplayString(_ctx.$t('remove')), 1)
          ]),
          _: 1,
          __: [29,30,31]
        }, 8, ["visible", "position"])
      ]),
      _: 1
    }, 40, ["id", "index", "highlight-condition", "CtcDropCondition", "CtrDropCondition", "RtrDropCondition", "RtcDropCondition", "type", "into-allowed", "callback-params", "element-name", "between-root-drop-via-indicator", "can-drop-to-root-check", "draggable"])), [
      [_vShow, !_ctx.element.isDeleting]
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (copyTipShown.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({ position: 'fixed', top: copyTipPos.y + 'px', left: copyTipPos.x + 'px', width: '0', height: '0', pointerEvents: 'none', zIndex: 9999 })
          }, [
            _createVNode(_component_q_tooltip, {
              modelValue: copyTipShown.value,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((copyTipShown).value = $event)),
              "no-parent-event": "",
              offset: [0, 8],
              anchor: "bottom middle",
              self: "top middle"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('link_copied_to_clipboard')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})